import {
  Badge,
  Button,
  ComboboxItem,
  Grid,
  Input,
  NumberFormatter,
  Text,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconSearch, IconUsers } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { cobalt_blue, green } from "../../../../const/variables";
import {
  getProvinceSelect,
  getTblDmCustomerGroupSelect,
} from "../../../../service/getSelectApi";
import { CellDoubleClickedEvent } from "ag-grid-community";

interface AccountantAccount {
  id: number;
  accountantAccount: string;
  accountantAccountName: string;
  accountLevel: number;
  createBy?: string | null;
  createDate?: Date | null;
  lastUpdateDate?: Date | null;
  lastUpdateBy?: string | null;
}

const FormAccount = ({
  params,
  handleChooseAccount,
  isChoose,
  editCodeForFees,
}: {
  params: CellDoubleClickedEvent<any>;
  handleChooseAccount?: any;
  isChoose?: boolean;
  editCodeForFees?: CellDoubleClickedEvent<any>;
}) => {
  const [data, setData] = useState<AccountantAccount[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [customerInfo, setCustomerInfo] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    keySearch: "",
    Phone: "",
    TaxCode: "",
    Code: "",
  });

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 25,
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const headerRef = React.useRef<HTMLDivElement>(null);

  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<any[]>([]);
  const gridSpan = { base: 12, sm: 2, md: 2, lg: 2, xl: 2 };
  const columns = React.useMemo<MRT_ColumnDef<AccountantAccount>[]>(
    () =>
      [
        {
          accessorKey: "id",
          header: "STT",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          Cell: ({ row }) => <Text size="12.5px">{row.index + 1}</Text>,
          size: 50,
        },
        {
          accessorKey: "accountantAccount",
          header: "Mã tài khoản",
          // Cell: ({ renderedCellValue, row }) => (
          //   <Badge
          //     radius="sm"
          //     variant="dot"
          //     size="lg"
          //     style={{ cursor: "pointer" }}
          //     color={renderedCellValue === null ? "red" : green.base}
          //   >
          //     {renderedCellValue === null ? null : renderedCellValue}
          //   </Badge>
          // ),
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          size: 250,
        },
        {
          accessorKey: "accountantAccountName",
          header: "Tên tài khoản",
          // Cell: ({ renderedCellValue }: any) => (
          //   <Text size="12.5px" fw={"bold"}>
          //     {renderedCellValue}
          //   </Text>
          // ),
          size: 300,
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
        {
          accessorKey: "accountLevel",
          header: "Cấp độ tài khoản",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          // Cell: ({ renderedCellValue }: any) => (
          //   <Text size="12.5px" fw={600}>
          //     {renderedCellValue}
          //   </Text>
          // ),
        },
        {
          accessorKey: "createDate",
          header: "Ngày tạo",
          Cell: ({ renderedCellValue }: any) => (
            <Text fw={600}>
              <NumberFormatter
                thousandSeparator={","}
                value={renderedCellValue}
              ></NumberFormatter>
            </Text>
          ),
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
        },
        {
          accessorKey: "lastUpdateDate",
          header: "Ngày cập nhật lần cuối",
          enableSorting: false,
          enableColumnActions: false,
          enableColumnFilter: false,
          // Cell: ({ renderedCellValue }: any) => (
          //   <Text size="12.5px" fw={600}>
          //     {renderedCellValue}
          //   </Text>
          // ),
        },
      ] as MRT_ColumnDef<(typeof data)[0]>[],
    []
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const dataCustomerGroupSelect = async () => {
    try {
      const getData = await getTblDmCustomerGroupSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
        type: item?.att1,
      }));
      setDataTblCustomerGroup(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }
    //   if (search.Code) {
    //     url += `&Code=${search.Code}`;
    //   }
    //   if (search.TaxCode) {
    //     url += `&TaxCode=${search.TaxCode}`;
    //   }
    //   if (search.Phone) {
    //     url += `&Phone=${search.Phone}`;
    //   }

    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmAccount/get-list${url}`
      );
      if (response && response.success) {
        let result = response?.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response?.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  const getDataProvinceId = async () => {
    const res = await getProvinceSelect();
    setDataProvinceSelect(
      res
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        }))
    );
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    //   getRowId: (row) => row?.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "62.5vh", minHeight: "300px" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: (e) => {
      setPagination(e);
    },
    // manualFiltering: true,
    manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        // handleChooseAccount(row.original, openFormAccount);
        if (params) {
          params.node.setDataValue(
            "codefund",
            String(row.original?.accountantAccount) ?? null
          );
          params.node.setDataValue(
            "attribute6",
            row.original?.accountantAccountName
          );
        }

        if (editCodeForFees) {
          editCodeForFees.node.setDataValue(
            "code",
            String(row.original?.accountantAccount) ?? null
          );
          params.node.setDataValue(
            "codeForFees",
            row.original?.accountantAccountName
          );
        }

        modals.closeAll();
      },
      sx: {
        cursor: "pointer", //you might want to change the cursor too when adding an onClick
      },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
          border: "1px solid #dee2e6",
          padding: "10px",
        }}
      >
        <Grid>
          <Grid.Col span={{ base: 12 }}>
            <Grid align="center" gutter={"xs"}>
              <Grid.Col span={gridSpan}>
                <Input
                  placeholder="Nhập từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconSearch
                      size={"20"}
                      color={cobalt_blue.base}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={gridSpan}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default FormAccount;
